import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import Safety from "./pages/Safety";
import Course from "./pages/Course";
import Feed from "./pages/Feed";
import About from "./pages/About";
import Stalls from "./pages/Stalls";
import Admin from "./pages/Admin";
import Drops from "./pages/Drops";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/safety" element={<Safety />} />
            <Route path="/kurs" element={<Course />} />
            <Route path="/feed" element={<Feed />} />
            <Route path="/about" element={<About />} />
            <Route path="/staelle" element={<Stalls />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/drops" element={<Drops />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </Layout>
        <Toaster
          position="top-center"
          toastOptions={{ style: { background: "#0B2230", border: "1px solid rgba(140,107,52,0.4)", color: "#EFE7D4" } }}
        />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
